import classNames from 'classnames'
import * as React from 'react'

import { TableCell, TableFooter } from '../../components/Table'
import { Checkbox, ColorVariant } from '../../components/checkbox'
import { useFinancialsTableContext } from '../../components/financials-table'
import { FinancialsRowDataType } from '../../components/financials-table/types'
import { View } from '../../components/line-stacked-bar-chart'
import { shortFormatNumber } from '../../util'
import { RevenueColumnsType, RevenueSettings } from './types'
import { getSumData } from './utils'

type Props = {
  columns: RevenueColumnsType['columns']
  data: FinancialsRowDataType[]
}

export function RevenueTableFooter({ columns, data }: Props) {
  const { settings, setSettings } = useFinancialsTableContext<RevenueSettings>()

  return (
    <TableFooter>
      {settings.chartView === View.bars ? (
        <TableCell hasLeading={false} className="border-l border-l-transparent pl-7">
          Total
        </TableCell>
      ) : (
        <TableCell hasLeading={false}>
          <Checkbox
            checked={settings.isShowAll}
            color={ColorVariant.gray}
            label="Total"
            className="cursor-pointer pl-px"
            size="none"
            onChange={() =>
              setSettings({
                ...settings,
                isShowAll: !settings.isShowAll,
              })
            }
          />
        </TableCell>
      )}
      {columns.map((column) => (
        <TableCell
          key={column.id}
          align={column.align}
          hasLeading={false}
          className={classNames(column.className, 'py-1')}
        >
          {shortFormatNumber(getSumData(data)[column.id])}
        </TableCell>
      ))}
    </TableFooter>
  )
}
